import Participant from "./Participant.js";

export default class RegistrationRow {
    constructor(row) {
        Object.keys(row).forEach(key => {
            if (key === "id") {
                this[key] = row[key];
            } else if (row[key]) {
                this[key] = new Participant(row[key].id, row[key].first_name, row[key].last_name);
            } else {
                this[key] = null;
            }
        });
    }
}